import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { DashboardColumnSort } from '../../models/dashboard-column-sort';
import { DashboardColumnSortDirection } from '../../models/dashboard-column-sort-direction.enum';

@Component({
  selector: 'epc-dashboard-column-sort',
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './dashboard-column-sort.component.html',
  styleUrls: ['./dashboard-column-sort.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardColumnSortComponent {
  @Input() public headerText: string;

  @Input() public field: string;

  @Input() public selectedSort?: DashboardColumnSort;

  @Output() public sortingChanged = new EventEmitter<DashboardColumnSort>();

  protected readonly DashboardColumnSortDirection =
    DashboardColumnSortDirection;

  public isActive(direction: DashboardColumnSortDirection) {
    return (
      this.field === this.selectedSort?.field &&
      direction === this.selectedSort?.direction
    );
  }

  public sortingClicked() {
    if (this.field !== this.selectedSort?.field) {
      this.sortingChanged.emit({
        field: this.field,
        direction: DashboardColumnSortDirection.Ascending,
      });
    } else {
      const newDirection = this.selectedSort?.direction
        ? DashboardColumnSortDirection.Ascending
        : DashboardColumnSortDirection.Descending;
      this.sortingChanged.emit({ field: this.field, direction: newDirection });
    }
  }
}
